<div *ngIf="card" class="card">
    <span class="title"
        >{{ card.providerName }}&nbsp;{{ 'common.card' | translate }}</span
    >
    <div class="barcode">
        <img [src]="card.barcode" />
        <span class="data">{{ card.barcodeData }}</span>
    </div>
</div>
